import React from 'react';
import './style.scss';
import { SomeWent_Wrong } from '../../../assets/images';
import ButtonComponent from '../ButtonComponent';
import { IoIosRefresh } from "react-icons/io";
import PropTypes from 'prop-types';

/* A crash gets one automatic refresh, and one only. Plenty of what lands here
   clears on its own — a bundle that moved under an open tab, a lazy import
   that did not arrive — and a refresh is what the user would have done anyway.
   A crash that comes back after that refresh is a real fault, so the screen
   stays put and the button hands the next attempt back to the user.

   Session storage, not local: the guard belongs to this tab and should not
   outlive it. */
const AUTO_REFRESH_KEY = "error-auto-refresh-attempted";

/* Straight away. Refreshing is what the user would have done on seeing the
   screen, so there is nothing to gain by making them look at it first. A timer
   rather than a direct call all the same, so React is left to finish
   committing the fallback before the page goes out from under it. */
const AUTO_REFRESH_DELAY_MS = 0;

/* Storage throws outright when cookies are blocked. Without it there is no way
   to tell a first crash from a repeat, so treat the one refresh as already
   spent rather than risk refreshing forever. */
const autoRefreshUsed = () => {
  try {
    return window.sessionStorage.getItem(AUTO_REFRESH_KEY) === "true";
  } catch {
    return true;
  }
};

const rememberAutoRefresh = () => {
  try {
    window.sessionStorage.setItem(AUTO_REFRESH_KEY, "true");
  } catch {
    /* Unreachable while autoRefreshUsed answers true on the same failure. */
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.refreshTimer = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    /* The refresh is scheduled here rather than in getDerivedStateFromError,
       which has to stay free of side effects. */
    if (autoRefreshUsed()) {
      return;
    }
    rememberAutoRefresh();
    this.refreshTimer = window.setTimeout(() => {
      window.location.reload();
    }, AUTO_REFRESH_DELAY_MS);
  }

  componentWillUnmount() {
    /* Nothing should reload a page this boundary is no longer showing on. */
    window.clearTimeout(this.refreshTimer);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div>
        <div className="OppsText">
          <span className="SomeWent_Wrong">
            {" "}
            <img src={SomeWent_Wrong} />
          </span>
          <h4 className="">
            Oops..! Something went wrong.Please try again later.
          </h4>
          <div>
            <p className="mb-0 informationStyle">
              Sorry, we can&apos;t process your request at the moment.
            </p>
            <p className="informationText informationStyle">
              Please try again later
            </p>
            <div className=" informationText ">
              <ButtonComponent
                className=" informationText informationStyle"
                text={
                  <span className="RefreshIcon">
                    <IoIosRefresh /> {`Refresh`}
                  </span>
                }
                onClick={() => {
                  window.location.reload();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
